import React, { ReactNode } from 'react';
import Link from '../../Link/viewer/Link';
import { LinkProps } from '../../Link/Link.types';

export type MenuButtonLinkProps = {
  wrapperProps: {
    positionInList?: string;
    ariaHasPopup?: boolean;
    isMoreButton?: boolean;
  };
  className?: string;
  children: ReactNode;
  link?: LinkProps;
  tabIndex?: number;
};

const MenuButtonLink: React.FC<MenuButtonLinkProps> = ({
  wrapperProps: { ariaHasPopup, isMoreButton },
  className,
  children,
  link,
  tabIndex,
}) => {
  const _getTabIndex = () => {
    return tabIndex || (isMoreButton || !link || !link.href ? 0 : undefined);
  };

  return (
    <Link
      {...link}
      aria-haspopup={!!ariaHasPopup}
      tabIndex={_getTabIndex()}
      className={className}
    >
      {children}
    </Link>
  );
};

export default MenuButtonLink;
